import { createI18n } from 'vue-i18n'
import tr from './locales/tr'
import en from './locales/en'
import el from './locales/el'

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('locale') || 'tr',
  fallbackLocale: 'tr',
  messages: {
    tr,
    en,
    el
  }
});


export function getLanguage() {
  return localStorage.getItem('locale') || 'tr'
}

export default i18n

// Type declarations for global properties
declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $t: typeof i18n.global.t;
    $i18n: typeof i18n.global;
  }
}
